import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { z } from "zod"

const templatesSearchSchema = z.object({
    search: z.coerce.string().optional().catch(""),
    page: z.coerce.number().catch(1),
    pageSize: z.coerce.number().catch(20),
})

export const Route = createFileRoute("/_app/manage/pathways/")({
    // validateSearch: (search: SearchSchemaInput) =>
    // pathwaysSearchSchema.parse(search),
    // loaderDeps: ({ search }) => search,
    validateSearch: (search: SearchSchemaInput) => templatesSearchSchema.parse(search),
    loaderDeps: ({ search }) => search,
    loader: () => {
        return Promise.resolve({})
    },
}) 